import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem('kanbr_admin_token');
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

// Convert relative /api/... image URLs to absolute
export const imgUrl = (u) => {
    if (!u) return '';
    if (u.startsWith('/api/')) return `${BACKEND_URL}${u}`;
    return u;
};

export const QUALITY_LABELS = { eco: 'Eco', prime: 'Prime', gold: 'Gold' };
export const QUALITY_KEYS = ['eco', 'prime', 'gold'];
export const QUALITY_DESC = {
    eco: 'Prelam HDHMR (White) + EBCO Fittings',
    prime: 'Prelam HDHMR (Brown Fabric) + EBCO Fittings',
    gold: 'Prelam HDHMR (Brown Fabric) + Hettich Fittings',
};

export const priceFor = (product, quality) => {
    if (!product) return 0;
    const q = (quality || 'eco').toLowerCase();
    if (q === 'gold') return product.price_gold ?? product.price_prime ?? product.price_eco ?? 0;
    if (q === 'prime') return product.price_prime ?? product.price_eco ?? 0;
    return product.price_eco ?? product.price_prime ?? product.price_gold ?? 0;
};

export const inr = (v) =>
    new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(v || 0);

export const CATEGORIES = [
    'Kitchen - Base Units',
    'Kitchen - Wall Units',
    'Kitchen - Tall Units',
    'Wardrobe',
    'Other Units',
];
